import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=6c9a8d1a&scoped=true&"
import script from "./ModalView.vue?vue&type=script&lang=ts&"
export * from "./ModalView.vue?vue&type=script&lang=ts&"
import style0 from "./ModalView.vue?vue&type=style&index=0&id=6c9a8d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a8d1a",
  null
  
)

export default component.exports